<section id="footer">
	<div class="layout-container">
		<div class="footer-links">
			<div fxLayout="row" fxLayout.lt-md="column" fxLayoutWrap="nowrap" fxLayoutGap="32px grid">
				<div fxFlex="60" fxFlex.lt-md="100">
					<div fxFlex="50">
						<h4 class="title">Product</h4>
						<ul role="list" class="footer-list">
							<li><a [routerLink]="['/products', 'hint']" [fragment]="'premium'">Hint Premium</a></li>
							<li><a [routerLink]="['/products', 'hint']" [fragment]="'pro'">Hint Pro</a></li>
							<li><a [routerLink]="'/products/expert'">Expert</a></li>
						</ul>
					</div>

					<div fxFlex="50">
						<h4 class="title">Company</h4>
						<ul class="footer-list">
							<li><a [routerLink]="'/'" [fragment]="'services'">About Us</a></li>
							<li><a [routerLink]="'/blogs'">Blogs</a></li>
							<li><a [routerLink]="'/resources'">Resources</a></li>
							<li><a [routerLink]="'/contact'">Contact</a></li>
							<li><a [routerLink]="'/policy/privacy-policy'">Privacy Policy</a></li>
							<li><a [routerLink]="'/terms/terms-of-use'">Terms of Use</a></li>
							<li><a [routerLink]="'/references/hint'">References</a></li>
							<li class="last"> <a [routerLink]="'/shipping/shipping-detail'">Shipping Detail</a></li>
						</ul>
					</div>
				</div>

				<div fxFlex="40">
					<h4 class="title">Clearcals</h4>
					<p>
						Clearcals is a digital health and nutrition startup founded in April 2020. Hint is an
						advanced health-tech application developed to make evidence-based nutrition care
						accessible. Providing personalized lifestyle interventions to patients suffering from
						and individuals at risk of chronic diseases is our area of interest.
					</p>
				</div>
			</div>
		</div>

		<div class="footer-copyrights" fxLayout="row" fxLayout.lt-md="column-reverse" fxLayoutGap="32px grid">
			<div fxFlex="60" fxFlex.lt-md="100">
				<p>© Copyright 2023 Clearcals.com - All Rights Reserved</p>
			</div>

			<div fxFlex="40" fxFlex.lt-md="100" class="social-footer-icons">
				<ul class="menu simple">
					<li>
						<a href="https://www.facebook.com/clearcals" target="_blank">
							<ic-icon [icon]="facebookIcon"></ic-icon>
						</a>
					</li>
					<li>
						<a href="https://www.instagram.com/hintnutrition/" target="_blank">
							<ic-icon [icon]="instagramIcon"></ic-icon>
						</a>
					</li>
					<li>
						<a href="https://www.linkedin.com/company/clearcals" target="_blank">
							<ic-icon [icon]="linkedinIcon"></ic-icon>
						</a>
					</li>
					<li>
						<a href="https://www.youtube.com/channel/UCiBHo9Ufovvs87wt2qDWGyw" target="_blank">
							<ic-icon [icon]="youtubeIcon"></ic-icon>
						</a>
					</li>
					<li>
						<a href="https://twitter.com/clearcalstweets" target="_blank">
							<ic-icon [icon]="twitterIcon"></ic-icon>
						</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
</section>